import { Map } from "ol";
import Feature from "ol/Feature";
import Geometry from "ol/geom/Geometry";
import Polygon from "ol/geom/Polygon";
import { ArrivalZoneListDto } from "~/api/GeneratedApi";
import i18 from "../../../translations/i18n";
import { LayerTitle } from "../types/layers";
import { CustomMapEventTypes } from "../types/map";
import { ArrivalZoneMapItem } from "../types/mapItems";
import { findSourceByTitle } from "./findSourceByTitle";

export function addArrivalZonesToMap(
  map: Map,
  services: ArrivalZoneListDto[],
): void {
  const source = findSourceByTitle(map, LayerTitle.ArrivalZones);

  if (!source) return;
  // Clear the source before adding
  source.clear();
  const features: Feature<Geometry>[] = [];
  services.forEach((e) => {
    // Convert to internal type
    const convertedItem = arrivalZoneToMapItem(e);
    if (!e.location) return;
    const transformed = [e.location.map((x) => [x.x, x.y])];

    const polygon = new Polygon(transformed);
    const feat = new Feature({
      geometry: polygon,
    });
    feat.setProperties({ ...convertedItem });
    feat.set("overlayOffsetY", -24);
    feat.setId(convertedItem.mapId);
    features.push(feat);
  });
  source.addFeatures(features);
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}

export function removeArrivalZones(map: Map): void {
  const source = findSourceByTitle(map, LayerTitle.ArrivalZones);
  if (!source) return;
  source.clear();
  source.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
  map.dispatchEvent(CustomMapEventTypes.FeaturesAdded);
}
export function arrivalZoneToMapItem(
  f: ArrivalZoneListDto,
): ArrivalZoneMapItem {
  return {
    ...f,
    mapId: `arrival-zone${f.id}`,
    type: "arrival-zone",
    name: `${i18.t("arrival-zones:arrival-zone")}-${f.name}`,
  };
}
